import { Box, Button, Card, styled, Typography } from '@mui/material';
import type { FC } from 'react';

type AvaniArticleCardProps = {
  title: string;
  image: string;
  link: string;
};

const AvaniStyledCard = styled(Card)(
  ({ theme }) => `
  padding: 16px;
  border-radius: 16px;
  width: 360px;
  height: 300px;
  display: flex;
  flex-direction: column;
  float: left;
  box-shadow: none;
`
);

export const AvaniArticleCard: FC<AvaniArticleCardProps> = ({ title, image, link }) => {
  return (
    <AvaniStyledCard title={title}>
      <Box
        sx={{
          height: 200,
          borderRadius: '12px',
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />

      <Typography
        variant="h5"
        title={title}
        sx={{
          mt: 1.5,
          height: '40px',
          lineHeight: '20px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical'
        }}
      >
        {title}
      </Typography>

      <Box sx={{ mt: 'auto', display: 'flex', justifyContent: 'flex-end', height: '40px' }}>
        <Button
          component="a"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          variant="text"
          sx={{ height: '40px', minHeight: '40px', px: 1 }}
        >
          Read More
        </Button>
      </Box>
    </AvaniStyledCard>
  );
};
